// Must match the category names actually used on the curated defaultitems
// minimal list (see scripts/update-default-items.js in the admin repo) —
// "Clothing"/"Essentials"/"Utensils" specifically, not the old "Clothes".
// A new group seeds its own `categories` field from this array once at
// creation (Root.js's addNewGroup), so any item whose own `categories`
// value doesn't match one of these names never appears in any category
// section — that mismatch was silently hiding ~half the minimal list
// (all Clothing, Essentials, and Utensils items) on every brand-new group.
export const CATEGORIES = [
    'Camping gear',
    'Clothing',
    'Essentials',
    'Toiletries',
    'Utensils',
    'Food',
    'Electronics',
    'Other stuff'
  ];

  export const SORT_CATEGORIES = [
    {id:'categories', title:'Items'},
    {id:'members', title:'Team members'},
  ];

  export const SHARE_CATEGORIES = [
    {id:'all', title:'All items'},
    {id:'current', title:'Current view'},
  ];
  export const ADD_CATEGORIES = [
    {id:'category', title:'Category'},
    {id:'item', title:'Item'},
  ];

  export const METHODS = [
    {id:'Bring', title:'Bring', abbreviation:'Br', ecoscore:5},
    {id:'Borrow', title:'Borrow', abbreviation:'Bw', ecoscore:5},
    {id:'Hire', title:'Hire', abbreviation:'H', ecoscore:5},
    {id:'Buy', title:'Buy', abbreviation:'B', ecoscore:1},
  ];

  export const WEATHERTIPS = [
    {id:'rain', title:'Rain', tip:'Make sure you bring enough wet weather gear!'},
    {id:'cloud', title:'Cloudy', tip:'A few clouds today.'},
    {id:'cold', title:'Cold', tip:'Bring warm stuff!'},
    {id:'hot', title:'Hot', tip:'Prepare for the heat by bringing enough water.'},
    {id:'storm', title:'Storm', tip:'Bring stuff to tie down tarps etc.'},
    {id:'sun', title:'Sunny', tip:'Make sure you pack a hat and sunscreen!'},
    {id:'suncloud', title:'Fine', tip:'Make sure you pack a hat and sunscreen!'},
    {id:'wind', title:'Windy', tip:'Bring stuff to tie down tarps etc.'},
  ]

  export const DEFAULTVALUES = [
    "Add information about hiring options at the festival if applicable",
    "Tip about hiring item (if applicable)",
    "Add tips on where or how to buy this item",
    "n/a",
    "<p>n/a</p>",
    "<p>N/A</p>",
    "<p></p>"
  ]